import { QueryConfig } from "store/utils/query-config";

export const groupsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["label"]
  }
};
